import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@components/button';

import * as Styled from './participants-card.styled';

type OwnProps = {
	participantCount: number;
	onClick: () => void;
};

const ParticipantsCard: React.FC<OwnProps> = ({ participantCount, onClick }) => {
	const { t } = useTranslation('promotions');
	return (
		<Styled.Wrapper>
			<Styled.Content>
				<Styled.Title>{t('participants')}</Styled.Title>
				<Styled.ParticipantsCountRow>
					<Styled.ParticipantsText>{t('participants_amount') + ':'}</Styled.ParticipantsText>
					<Styled.ParticipantsCount>{participantCount}</Styled.ParticipantsCount>
				</Styled.ParticipantsCountRow>
				<Button size='large' color='dark' onClick={onClick}>
					{t('look_participants')}
				</Button>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default ParticipantsCard;
